<template>
  <div class="sleep_root_div">
    <div class="page-header header1">
      <div class="bluebar head_logo"></div>
      <div>
        {{ $t("message")["Sleep.title"] }}&nbsp;&nbsp;&nbsp;&nbsp;{{
          data_date
        }}
      </div>
      <div style="margin-left: auto">
        <a-button style="margin-right: 15px" @click="exportToCSV">{{
          $t("message")["Export.button.name"]
        }}</a-button>
        <a-date-picker
          id="date_picker"
          @change="ChangeDataDate"
        ></a-date-picker>
      </div>
    </div>
    <div id="sleep_result_div">
      {{ alltime_hour }}{{ $t("message")["Sleep.hour"] }}{{ alltime_minte
      }}{{ $t("message")["Sleep.minute"] }}
    </div>
    <div id="sleep_chart"></div>
    <div id="analyze_area">
      <div id="analyze_chart">
        <div id="sleep_chart_title">
          <div class="bluebar" style="margin-right: 10px"></div>
          <div class="title_text">{{ $t("message")["HeartRate.sporthr"] }}</div>
          <div class="score_text">
            <div class="value">{{ sleep_score }}</div>
            <div class="unit">{{ $t("message")["Sleep.score"] }}</div>
          </div>
        </div>
        <div id="sleep_percent_chart"></div>
      </div>
      <div id="analyze_data">
        <div id="sleep_comment">
          {{ $t("message")["Sleep.score.prefix"] }}:{{ sleep_score
          }}{{ $t("message")["Sleep.score"] }},{{
            $t("message")["Sleep.bless"]
          }}
        </div>
        <SleepListItemView
          v-for="(item, index) in listData"
          :sleepModel="item"
          v-bind:key="index"
        >
        </SleepListItemView>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import echarts from "echarts";
import SleepListItemView from "../../components/sleep/SleepListItem.vue";
import domain from "../../domain";
import request from "../../utils/request";
const moment = require('moment');

var chart
var chartOption
export default {
  data() {
    return {
      data_date:"",
      deviceid:"",
      device_type: 1,
      uid: "",
      listData: [],
      chartData: [],
      allTime:0,
      sleep_Allhour: 0,
      lightSleep_allTime:0,
      deepSleep_allTime:0,
      NoSleep_allTime:0,
      Rem_allTime:0,
      sleep_score:"--",
      light_present:0,
      deep_present:0,
      no_present:0,
      rem_present:0,
      start_time:null,
      end_time:null,
      deviceId:"",
      today_year:"",
      today_month:"",
      today_day:"",
      alltime_hour:"--",
      alltime_minte:"--",
      presentSleep:0,
    };
  },
  components: {
    SleepListItemView
  },
  watch: {
    "$store.state.windowWidth": function() {
      var w
      if (this.$store.state.fullscreen) {
        w = this.$store.state.windowWidth * 0.6 + 'px'
      } else {
        w = this.$store.state.windowWidth * 0.7 + 'px'
      }
      document.getElementById('sleep_chart').style.width = w
      chart.resize()
    }
  },
  mounted: function() {
    this.device_type = sessionStorage.getItem("device_type");
    this.deviceid = sessionStorage.getItem("deviceid");
    if(this.device_type==2){
        this.uid = sessionStorage.getItem("uid");
    }

    this.data_date = this.$route.params.data_date;
    this.fetchSleepData(this.deviceid,this.data_date);
  },
  methods: {
    getFormatSleepTimeStr(time){
      if(time>60){
        return `${Math.floor(time/60)} ${this.$t("message")['Sleep.hour']} ${Math.floor(time)%60} ${this.$t("message")['Sleep.minute']}`
      }else{
        return `${Math.floor(time)} ${this.$t("message")['Sleep.minute']}`
      }
    },
    getTypeStr(type){
      if(type===4){
        return this.$t("message")['Sleep.deep'];
      } else if(type===6){
        return this.$t("message")['Sleep.awake'];
      } else if(type===7){
        return this.$t("message")['Sleep.rem'];
      } else{
        return this.$t("message")['Sleep.light'];
      }
    },
    exportToCSV(){
      const exSleep =[]
      if(this.chartOption!==undefined && this.chartOption.series!==undefined){
        const dataList = this.chartOption.series[0].data
        if(dataList.length>0){
          let lastTime = 0
          const st = moment(this.start_time)
          for(let i=0;i<dataList.length;i++){
            const oneStValue = Math.floor(dataList[i][0])
            st.add(oneStValue - lastTime,'minute')
            lastTime = oneStValue
            const oneSleep = {
              stTime: st.format("HH:mm"),
              type: this.getTypeStr(dataList[i][2]),
              duration: this.getFormatSleepTimeStr(Math.floor(dataList[i][1]-oneStValue))
            }
            exSleep.push(oneSleep)
          }
        }
      }

      const msg = this.$t("message")
      const nickName = sessionStorage.getItem("nickname");
      let csvData = `${msg['Export.Base.title']}\n`; // 第一行
      csvData += `${msg['Export.Base.nickname']},${nickName},${msg['Export.Base.deviceId']},\'${this.deviceid},${msg['Export.Base.date']},${this.data_date}\n`  //第二行
      csvData += `\n${msg['Export.Sleep.title']}\n`  //第三行
      csvData += `${msg['Export.Sleep.total']},${this.getFormatSleepTimeStr(this.allTime)},${msg['Export.Sleep.start']},${this.start_time},${msg['Export.Sleep.end']},${this.end_time}\n`  //第四行
      csvData += `${msg['Export.Sleep.deep']},${this.getFormatSleepTimeStr(this.deepSleep_allTime)},${msg['Export.Sleep.light']},${this.getFormatSleepTimeStr(this.lightSleep_allTime)},${msg['Export.Sleep.rem']},${this.getFormatSleepTimeStr(this.Rem_allTime)},${msg['Export.Sleep.wake']},${this.getFormatSleepTimeStr(this.NoSleep_allTime)}\n`  //第五行
      csvData += `\n${msg['Export.Base.details']}\n`   //第六行
      csvData += `${msg['Export.Base.times']},${msg['Export.Sleep.cycle']},${msg['Export.Sleep.duration']}\n`   //第六行
      exSleep.forEach((item) => {
        csvData += `${item.stTime},${item.type},${item.duration}\n`; // 数据行
      });

      //csv
      const csvFileName = `${nickName}_${this.deviceid}_Sleep_${this.data_date}.csv`
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;'});
      // 创建一个指向Blob对象的URL
      const url = window.URL.createObjectURL(blob);
      // 创建一个隐藏的<a>元素并模拟点击以触发下载
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', csvFileName); // 设置下载文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // 清理
    },

    drawTimeBarChart() {
      let that = this;
      var myChart2 = echarts.init(document.getElementById("sleep_chart"));
      var option = {
        title: {
          text: "",
          left: "center",
          textStyle: {
            color: "#343434",
            fontSize: "14"
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            if(params.data[2]==4){
              return that.$t("message")['Sleep.deep'];
            } else if(params.data[2]==6){
              return that.$t("message")['Sleep.awake'];
            } else if(params.data[2]==7){
              return that.$t("message")['Sleep.rem'];
            } else{
              return that.$t("message")['Sleep.light'];
            }
          },
        },
        xAxis: {
          scale: true,
          splitLine:{
            show:false
          },
          axisLabel: {
            show: true,
            fontSize: 12,
            color: "#999999",
             formatter: (value) => {
              if (value<500) {
                var strtime = this.start_time+"";
                strtime = strtime.replace(/-/g,"/");
                var date = new Date(strtime);
                var aDate = new Date(
                date.getYear(),
                date.getMonth(),
                date.getDay(),
                date.getHours(),
                date.getMinutes()+ value*this.allTime*0.002,
                0
              );
                var ahour,bminute;
                if (aDate.getHours()<10) {
                  ahour = "0"+aDate.getHours();
                }else{
                  ahour = ""+aDate.getHours();
                }
                if (aDate.getMinutes()<10) {
                  bminute = "0"+aDate.getMinutes();
                }else{
                  bminute = ""+aDate.getMinutes();
                }
              var texts = [ahour, bminute];
              return texts.join(":");
            }else{
                var endtime = this.end_time;
                endtime = endtime.replace(/-/g,"/");
                var date = new Date(endtime);
                var aDate = new Date(
                date.getYear(),
                date.getMonth(),
                date.getDay(),
                date.getHours(),
                date.getMinutes()+ 0,
                0
              );
                var ahour,bminute;
                if (aDate.getHours()<10) {
                  ahour = "0"+aDate.getHours();
                }else{
                  ahour = ""+aDate.getHours();
                }
                if (aDate.getMinutes()<10) {
                  bminute = "0"+aDate.getMinutes();
                }else{
                  bminute = ""+aDate.getMinutes();
                }
              var texts = [ahour, bminute];
              return texts.join(":");
            }
            }
          }
        },
        yAxis: {
          show: false
        },
        series: [
          {
            type: "custom",
            renderItem: function(params, api) {

              var yValue = 3;
              if(api.value(2)==4){
                yValue = 1;
              } else if(api.value(2)==6){
                yValue = 7;
              } else if(api.value(2)==7){
                yValue = 5;
              }

              var start = api.coord([api.value(0), yValue]);
              var size = api.size([api.value(1) - api.value(0), yValue]);
              var style = api.style();

              return {
                type: "rect",
                shape: {
                  x: start[0],
                  y: start[1],
                  width: size[0],
                  height: size[1]
                },
                style: style
              };
            },
            label: {
              normal: {
                show: false,
                position: "top"
              }
            },
            dimensions: ["from", "to", "profit"],
            encode: {
              x: [0,1],
              y: [2],
              tooltip: [0, 1, 2],
              itemName: 2
            },
            data: this.chartData,
            itemStyle: {
              normal: {
                color: params => {
                  if (params.data[2] == 6) {//清醒
                    return "#FADEAF";
                  } else if (params.data[2] == 4) {//深睡
                    return "#427FF7";
                  } else if (params.data[2] == 7) {//眼动
                    return "#9899F5";
                  } else {
                    return "#93C0FA";
                  }
                }
              }
            }
        }]
      };
      myChart2.setOption(option);
      this.chartOption = option
      this.chart = myChart2
    },
    drawTimePercentChart() {
      var dom = document.getElementById("sleep_percent_chart");
      var myChart = echarts.init(dom);
      myChart.setOption({
      tooltip: {
          trigger: 'item'
      },
      legend: {
          bottom: '0',
          left: 'center'
      },
      series: [
      {
          name: '睡眠',
          type: 'pie',
          radius: ['40%', '60%'],
          avoidLabelOverlap: false,
          itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
          },
          label: {
              show: false,
              position: 'center'
          },
          emphasis: {
              label: {
              show: true,
              fontSize: 30,
              fontWeight: 'bold'
              }
          },
          labelLine: {
              show: false
          },
          data: [
              { value: this.listData[0].time, name: this.$t("message")['Sleep.light'], itemStyle: { color: '#93C0FA' } },
              { value: this.listData[1].time, name: this.$t("message")['Sleep.deep'], itemStyle: { color: '#427FF7' } },
              { value: this.listData[2].time, name: this.$t("message")['Sleep.awake'], itemStyle: { color: '#FADEAF' } },
              { value: this.listData[3].time, name: this.$t("message")['Sleep.rem'], itemStyle: { color: '#9899F5' } },
          ]
      }
      ]
      });
    },
    getSleepDataList() {
      this.listData = [
        {
          type: 3,
          name: this.$t("message")["Sleep.light"],
          persent:this.light_present,
          hour: Number(this.lightSleep_allTime/60).toFixed(2),
          time: this.lightSleep_allTime,
          ptext: this.$t("message")["Sleep.light_desc"]
        },
        {
          type: 4,
          name: this.$t("message")["Sleep.deep"],
          persent: this.deep_present,
          hour: Number(this.deepSleep_allTime/60).toFixed(2),
          time: this.deepSleep_allTime,
          ptext: this.$t("message")["Sleep.deep_desc"]
        },
        {
          type: 6,
          name: this.$t("message")["Sleep.awake"],
          persent: this.no_present,
          hour: Number(this.NoSleep_allTime/60).toFixed(2),
          time: this.NoSleep_allTime,
          ptext: this.$t("message")["Sleep.awake_desc"]
        },
        {
          type: 7,
          name: this.$t("message")["Sleep.rem"],
          persent: this.rem_present,
          hour: Number(this.Rem_allTime/60).toFixed(2),
          time: this.Rem_allTime,
          ptext: this.$t("message")["Sleep.rem_desc"]
        }
      ];
    },

    /**
     *   调用接口  获取睡眠数据
     */
    fetchSleepData (deviceid,data_date) {
      let momentDate = moment(data_date);
      let next_date = momentDate.add(1, 'day').format('YYYY-MM-DD')
      let reqParams = {
          device_id: deviceid,
          start_date: data_date,
          end_date: next_date
        };
      let reqUrl = domain.URLS.sleepDataUrl;
      let that = this;
      if(this.device_type == 2){
        momentDate = moment(data_date);
        let prev_date = momentDate.subtract(1, 'day').format('YYYY-MM-DD')
        reqParams = {
          uid: this.uid,
          start_date: prev_date,
          end_date: data_date
        };
        reqUrl = domain.URLS.sleepBleDataUrl;
      }
      request({
        url: reqUrl,
        methods: "GET",
        params: reqParams
      })
      .then(response => {
          if (response.data.ReturnCode == 0) {
            that.chartData = echarts.util.map(that.chartData, function(item, index) {
            return {
              value: item
            };
          });
          that.drawTimeBarChart();
          that.setSleepData(response.data.Data[0])
          that.drawTimePercentChart();
        } else{
          that.clearSleepData()
        }
      })
    },

      setSleepData(data){
        var Start_time = data.start_time
        var End_time = data.end_time
        var Light_sleep_time = data.light_sleep
        var Deep_sleep_time = data.deep_sleep
        var rem_sleep_time = data.eyemove_sleep
        var Score = data.score
        var json_sleep_str = data.sleep_section.replace(/\\/g,'');

        var Sleep_segment = JSON.parse(json_sleep_str)

        var dateBegin = new Date(Start_time.replace(/-/g, "/"));
        var dateEnd = new Date(End_time.replace(/-/g, "/"));
        var dateDiff = dateEnd.getTime() - dateBegin.getTime();//时间差的毫秒数
        var AllSleep_minutes = Math.floor(dateDiff / (60 *1000));
        var aa = []
        var presentSleep = 0
        for (var i = 0; i < Sleep_segment.length; i++) {
          if (i==Sleep_segment.length-1) {
            presentSleep = 500/Sleep_segment[i].et
          }
        }
        for (var i = 0; i < Sleep_segment.length; i++) {
          var sleepOne = Sleep_segment[i]
          var sDeatail = [sleepOne.st,sleepOne.et,sleepOne.type,'A']
          sleepOne.st = sleepOne.st*presentSleep
          sleepOne.et = sleepOne.et*presentSleep
          sDeatail = [sleepOne.st,sleepOne.et,sleepOne.type,'A']
          aa.push(sDeatail)
        }

        this.sleep_score = Score
        this.allTime = AllSleep_minutes
        this.lightSleep_allTime = Light_sleep_time
        this.deepSleep_allTime = Deep_sleep_time
        this.Rem_allTime = rem_sleep_time
        this.NoSleep_allTime = AllSleep_minutes-Light_sleep_time-Deep_sleep_time-rem_sleep_time
        this.light_present = (this.lightSleep_allTime/this.allTime*100).toFixed(2)
        this.deep_present = (this.deepSleep_allTime/this.allTime*100).toFixed(2)
        this.no_present = (this.NoSleep_allTime/this.allTime*100).toFixed(2)
        this.rem_present = (this.Rem_allTime/this.allTime*100).toFixed(2)

        this.start_time = Start_time
        this.end_time = End_time

        this.alltime_hour = parseInt(AllSleep_minutes/60)
        this.alltime_minte = AllSleep_minutes%60
      
        this.chartOption.series[0].data = aa
        this.chart.clear();
        this.chart.setOption(this.chartOption)
        this.getSleepDataList();
      },

      clearSleepData(){
        this.sleep_score = "--"
        this.allTime = 0
        this.lightSleep_allTime = 0
        this.deepSleep_allTime = 0
        this.Rem_allTime = 0
        this.NoSleep_allTime = 0
        this.light_present = 0
        this.deep_present = 0
        this.no_present = 0
        this.rem_present = 0

        this.start_time = null
        this.end_time = null

        this.alltime_hour = "--"
        this.alltime_minte = "--"
      
        this.chartOption.series[0].data = []
        this.chart.clear();
        this.chart.setOption(this.chartOption)
        this.getSleepDataList();
      },

      ChangeDataDate(val){
        let date_str = val.format('YYYY-MM-DD');
        this.data_date = date_str;
        this.fetchSleepData(this.deviceid,this.data_date);
        this.chartData = echarts.util.map(this.chartData, function(item, index) {
          return {
            value: item
          };
        });
      }

  },
};
</script>

<style scoped lang="scss">
.sleep_root_div {
  padding-bottom: 10px;
  position: relative;
  left: 0px;
  border: 1px solid white;
}

.page-header {
  height: 50px;
  font-size: 16px;
  color: #292929;
  letter-spacing: 0;
  line-height: 30px;
  font-weight: bold;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  align-items: center;
}

.header1 {
  justify-content: space-around;
}

.bluebar {
  width: 4px;
  height: 13px;
  background-color: #2284FF;
}

.head_logo {
  margin-right: 10px;
}

#sleep_chart {
  margin-top:20px;
  height: 380px;
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
}

#sleep_result_div {
  font-weight: bold;
  font-size: 16px;
  color: #292929;
  display: flex;
  align-items: center;
  margin-left: 12px;
}

#date_picker {
  margin-left: auto;
}

#analyze_area {
  display: flex;
  justify-content: space-around;
  height: 300px;
}

#analyze_chart {
  width: 490px;
}

#analyze_data {
  width: calc(100% - 560px);
}

#sleep_comment {
  background-color: #F4F4F4;
  color: #292929;
  height: 34px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 6px;
}

#sleep_chart_title {
    display: flex;
    align-items: center;
    margin-top: 10px;
} 

.bluebar {
    width: 4px;
    height: 13px;
    background-color: #2284FF;
}

.title_text {
    color: #292929;
    font-size: 15px;
    font-family: PingFang SC-Medium;
}

.score_text {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.value {
  color: #292929;
  font-size: 16px;
}

.unit {
  color: #6B6B6B;
  font-size: 12px;
}

#sleep_percent_chart {
    width: 100%;
    height: 250px;
}
</style>
